// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import './styles/global.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import AppRoutes from './components/routing/AppRoutes';
import { AuthProvider } from './context/auth';
import { HubProvider } from './context/hub';
import { TaskProvider } from './context/task';

const Root: React.FC = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <HubProvider>
            <TaskProvider>
              <AppRoutes />
            </TaskProvider>
          </HubProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
